export default __webpack_public_path__ + "static/jameelMotorsLogoOld-5de644b67c2f2f0f8878ee3a34d34e80.svg";